import axios from '@/request';
import qs from 'qs';

export default {
  async getLogs(params: any) {
    return axios.get('wechatdown/list', { params });
  }
};
